<template>
  <AbsPopup id="AdultPopup" title="인증하기" type="confirm" :initButtonList="buttonList" @close="$emit('close')">
    <template #body>
      <div class="body">
        <div class="myproofBody">
          <div class="Bar title">
            <span>STEP.01 본인인증 (필수)</span>
            <span>휴대폰 인증</span>
          </div>
          <div v-if="!myproof">
            <div class="descriptionBody">
              <span>고객님의 개인정보 보호 및 본인확인을 위하여 본인 인증이 필요 합니다.<br />아래의 '인증하기'버튼을 클릭해 본인 인증을 진행해 주세요</span>
            </div>
            <div class="box">
              <ul>
                <li>
                  <span>신상 도용은 범죄 행위 입니다.</span>
                </li>
                <li>
                  <span>타인의 신상 도용 시 주민등록법에 따라 3년 이하의 징역이나 1천만원 이하의 벌금에 처해지며, 사전통보 없이 회원가입이 취소될 수 있습니다.</span>
                </li>
              </ul>
            </div>
            <div class="myproof">
              <div class="phoneInput">
                <UInput type="text" placeholder="" line="bottom" v-model="phone" @enter="checkPhone">
                  <span>휴대폰</span>
                </UInput>
                <Ubutton text="확인" size="xxsmall" iconSize="xsmall" :state="phoneState" @click.native="checkPhone"/>
              </div>
              <div class="error">
                <span :class="phoneErrorState">{{ phoneError }}</span>
              </div>
              <div class="button">
                <Ubutton size="small" text="인증 하기" :state="phoneState" @click.native="myproofclick"/>
              </div>
            </div>
          </div>
          <div v-else class="success">
            <div>
              <span>인증번호 : </span><span>{{ phone }}</span>
            </div>
            <div class="agree">
              <input type="checkbox" id="myagree" v-model="myproof" :disabled="true"/>
              <label for="myagree">
                <span>본인인증 완료</span>
              </label>
            </div>
          </div>
        </div>
        <div class="adultBody" :class="{guide: !myproof}">
          <div class="Bar" :class="{title: myproof}">
            <span>STEP.02 성인인증 ({{ isAdult ? '필수' : '선택'}})</span>
            <span>본인 인증 필요</span>
          </div>
          <div v-if="!myproof" class="center">
            <span>본인인증이 필요 합니다.</span>
          </div>
          <div v-else>
            <div v-if="!adult">
              <div class="descriptionBody">
                <span>성인 인증을 통해 성년으로 확인되면 성인 전용 포스트를 발행하거나 열람 할 수 있습니다. 스담에서 적용하는 성년 기준은 대한민국 국민의 경우 한국 나이 20세 이상입니다. 한 사람의 명의로 하나의 계정만 성인 인증을 받을 수 있습니다. <a href="/terms/adultcontent" target="_blank"><u class="require">성인인증 정책 자세히 보기</u></a></span>
              </div>
              <div v-if="myproof" class="button">
                <Ubutton size="small" text="인증 하기" state="active" @click.native="adultClick"/>
              </div>
            </div>
            <div v-else class="success">
              <div>
                <a href="/terms/adultcontent" target="_blank"><u class="require">성인인증 정책 자세히 보기</u></a>
              </div>
              <div class="agree">
                <input type="checkbox" id="adult" v-model="adult" :disabled="true"/>
                <label for="adult">
                  <span>성인인증 완료</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="adultOpen" :class="{guide: !adult}">
          <div class="Bar" :class="{title: adult}">
            <span>STEP.03 성인 콘텐츠 열람 ({{ isOpen ? '필수' : '선택'}})</span>
            <span>성인 인증 필요</span>
          </div>
          <div v-if="!myproof" class="center">
            <span>성인인증이 필요 합니다.</span>
          </div>
          <div v-else>
            <div class="descriptionBody">
              <span>이 기능을 활성화하면 스담 전체 서비스에 성인 콘텐츠가 표시되고 내용을 열람할 수 있습니다. 성인인증을 통해 성년인 것이 확인된 사람만 이 기능을 활성화 할 수 있습니다.</span>
            </div>
            <div class="agree">
              <input type="checkbox" id="adultStep" v-model="adultStep" />
              <label for="adultStep">
                <span>위의 내용에 동의 합니다.</span>
              </label>
            </div>
            <div class="button">
              <Ubutton size="small" :text="adultOpen? '열람 취소' : '열람 하기'" :state="adultStep? 'require' : 'disable'" @click.native="adultOpenClick"/>
            </div>
          </div>
        </div>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import UInput from '@/components/base/UInput.vue'
import {getTime, phoneToNumber, numberToPhone} from '@/components/js/Utils'

export default {
  props: {
    option: {
      type: Object
    }
  },
  created () {
  },
  mounted () {
    console.log(this.option)
    this.$emit('loading', false)
  },
  beforeDestroy () {
  },
  data () {
    return {
      isOpen: this.option.param.type === 'adult',
      isAdult: this.option.param.type !== 'proof',
      myproof: this.option.param.myproof,
      // myproof: true,
      adult: this.option.param.adult,
      // adult: true,
      adultOpen: this.option.param.adultopen,
      adultStep: this.option.param.adultopen,
      phone: (this.option.param.phone) ? this.option.param.phone : '',
      phoneState: 'disable',
      phoneError: '',
      phoneErrorState: 'require'
    }
  },
  name: 'AdultPopup',
  watch: {
    phone (val) {
      if (val === null || val === undefined) {
        this.phoneError = ''
        this.phoneErrorState = 'require'
        this.phoneState = 'disable'
      } else {
        this.phone = numberToPhone(val)
        this.phoneState = 'deactive'
      }
    }
  },
  computed: {
    buttonList () {
      return [
        {name: '취소', state: 'deactive', click: () => { this.$emit('close') }},
        {name: '확인', state: this.buttonState, click: this.submit}
      ]
    },
    buttonState () {
      if ((this.myproof && this.adult) || (this.myproof && !this.isAdult)) {
        return 'active'
      }
      return 'disable'
    }
  },
  methods: {
    checkPhone () {
      if (this.phone !== '' && this.phone !== null) {
        this.$http.post('/api/auth/isPhone', {phone: phoneToNumber(this.phone)}).then((e) => {
          if (e.success) {
            if (e.data) {
              this.phoneError = '이미 사용중인 전화번호 입니다.'
              this.phoneErrorState = 'require'
              this.phoneState = 'deactive'
              this.emailButtonState = 'disable'
            } else {
              this.phoneError = '사용 가능한 전화번호 입니다.'
              this.phoneErrorState = 'active'
              this.phoneState = 'active'
              this.emailButtonState = 'in-active'
            }
          } else {
            // 통신에러?
          }
        })
      }
    },
    myproofclick () {
      console.log('myproofclick')
      if (this.phone !== '' && this.phoneState === 'active') {
        window.IMP.certification({
          company: 'https://upenbe.com',
          merchant_uid: this.$store.getters.id + getTime(),
          phone: this.phone
        }, (rsp) => {
          console.log('myproofclick cc', rsp)
          if (rsp.success) {
            this.$http.post('/api/user/certification', {imp: rsp.imp_uid, phone: this.phone}).then(es => {
              console.log(es)
              if (es.success) {
                this.option.param.myproof = true
                this.myproof = true
                // this.phone = numberToPhone(e.data)
              }
            })
          }
        })
      }
    },
    adultClick () {
      window.IMP.certification({
        company: 'https://upenbe.com',
        merchant_uid: this.$store.getters.id,
        min_age: 19,
        name: this.option.param.name,
        phone: this.phone,
        birth: this.option.param.birth
      }, (rsp) => {
        console.log(rsp)
        if (rsp.success) {
          this.$http.post('/api/user/certificationAdult', {imp: rsp.imp_uid}).then(e => {
            console.log(e)
            if (e.success) {
              this.option.param.adult = true
              this.adult = true
            }
          })
        } else {
          this.adult = false
        }
      })
    },
    adultOpenClick () {
      this.$http.post('/api/user/adultChange', {open: !this.adultOpen}).then(e => {
        console.log(e)
        if (e.success) {
          this.adultOpen = e.data
        }
      })
    },
    submit () {
      console.log('submit')
      if (this.buttonState === 'active') {
        this.$emit('submit', this.option.param)
      }
    }
  },
  components: {
    AbsPopup,
    UInput
  }
}
</script>

<style scoped>
#AdultPopup {
  padding: 10px 0;
  width: 500px;
  color: var(--text-base);
}
.body {
  display: flex;
  flex-direction: column;
  margin: 5px 0px;
  padding: 15px;
  line-height: 26px;
  text-align: left;
}
.body > div {
  display: flex;
  flex-direction: column;
}
.body > div:nth-last-child(1n+2) {
  margin-bottom: 20px;
}
.body .success {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 10px 10px;
}
.body .Bar {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 0px 5px;
  margin-bottom: 10px;
  align-items: center;
  border-bottom: 1px solid var(--line-guide);
}
.body .Bar.title {
  border-bottom: 1px solid var(--line-base);
}
.body .Bar span:first-child {
  font-weight: bold;
}
.body .Bar span:last-child {
  margin-left: auto;
}
.body .descriptionBody {
  padding-left: 5px;
}
.body .box {
  border: 1px dashed var(--line-guide);
  padding: 5px 5px;
  font-size: 0.95em;
  /* letter-spacing: -0.02em; */
}
.body ul {
  padding-left: 20px;
}
.body .myproof {
  flex-direction: column;
}
.body .phoneInput {
  display: flex;
  justify-content: center;
  margin: 10px 0px;
}
.body .error {
  display: flex;
  justify-content: center;
}
.body .button {
  display: flex;
  margin-top: 10px;
  align-items: center;
  justify-content: center;
}
.body .agree {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-left: auto;
}
.body .agree input[type=checkbox] {
  display: none;
}
.body .agree input[type=checkbox] + label {
  position: relative;
  display: inline-block;
  padding-left: 23px;
  cursor: pointer;
}
.body .agree input[type=checkbox] + label::before {
  content: '';
  color: var(--line-base);
  position: absolute;
  line-height: 14px;
  width: 14px;
  height: 14px;
  border-radius:14px;
  border: 2px solid var(--line-base);
  left: 0px;
  text-align: center;
  top: 50%;
  font-size: 14px;
  transform: translateY(-50%);
}
.body .agree input[type=checkbox]#adult + label::before {
  content: 'x';
  color: var(--active);
  position: absolute;
  line-height: 14px;
  width: 14px;
  height: 14px;
  border-radius:14px;
  border: 2px solid var(--active);
  left: 0px;
  text-align: center;
  top: 50%;
  font-size: 14px;
  transform: translateY(-50%);
}
.body .agree input[type=checkbox]#adultStep + label::before {
  content: '';
  color: var(--line-base);
  position: absolute;
  line-height: 14px;
  width: 14px;
  height: 14px;
  border-radius:14px;
  border: 2px solid var(--line-base);
  left: 0px;
  text-align: center;
  top: 50%;
  font-size: 14px;
  transform: translateY(-50%);
}
.body .agree input[type=checkbox]:checked + label::before {
  content: 'v';
  color: var(--active);
  border: 2px solid var(--active);
}
.body .agree input[type=checkbox]:checked + label {
  color: var(--active);
}
.body .agree input[type=checkbox]#adult:checked + label::before {
  content: 'v';
  color: var(--active);
  border: 2px solid var(--active);
}
.body .agree input[type=checkbox]#adult:checked + label {
  color: var(--active);
}
.body .agree input[type=checkbox]#adultStep:checked + label::before {
  content: 'v';
  color: var(--require);
  border: 2px solid var(--require);
}
.body .agree input[type=checkbox]#adultStep:checked + label {
  color: var(--require);
}
.adultOpen .agree {
  margin-top: 10px;
}
.adultBody .center, .adultOpen .center {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/AdultPopup.vue